export interface IMetricData extends IMetricDataPairs {
  agentName: string;
  agentReferenceId: string;
}

export interface IMetricDataPairs {
  allocatedCases: IMetric;
  performanceLevel: IMetric;
  cashCollected: IMetric;
  cashTargetAchievement: IMetric;
  emiCollectionEfficiency: IMetric;
  emiCETargetAchievement: IMetric;
  coverage: IMetric;
  ptp: IMetric;
  ptpConversion: IMetric;
}
export interface IMetric {
  metricLabel: string;
  metricValueMTD: number;
  metricValueLMSD: number;
  changeInMetricValueFromLMSD: number;
  metricFormat: FormatType;
  isPositiveMetric: boolean;
}

export interface IMetricChange {
  value: number;
  change: number;
  metricFormat: FormatType;
}

export interface IMetricChangeCell {
  metric: IMetricChange;
}

export interface IOverallMetricTooltip {
  data: {
    currentValue: number;
    lmsdValue: number;
    metricFormat: FormatType;
  };
}

export enum FormatType {
  PERCENT = 'percent',
  NUMBER = 'number',
  AMOUNT = 'amount'
}

export interface IOverallMetricSummaryItem {
  metricKey: string;
  metricFormat?: FormatType;
  value?: number;
  className?: string;
  loading?: boolean;
}

export interface IOverallMetricGroupItem {
  metricGroup: {
    metricGroupLabel: string;
    metricKeyList: Array<keyof IMetricDataPairs>;
  };
  isLast: boolean;
}

export interface IOverallMetricGroupSubItem {
  metric: keyof IMetricDataPairs;
}
